(function () {
    'use strict';

    Directives.HoneyTipDirective = function HoneyTipDirective() {

        // @ngInject

        function HoneyTipDirectiveCtor($scope, $injector, HoneyTipsManager, AppConfigService) {

            this.constructor.$super.call(this, $scope, $injector);
            this.__objectType = 'GenerateTagsListDirectiveController';

            this.HoneyTipsManager = HoneyTipsManager;

            this.showHoneyTips = AppConfigService.appConfiguration().show_honey_tips;
            if (this.showHoneyTips) {
                this.tip = HoneyTipsManager.getRandomTip();
            }
            this.tipLiked = false;
            this.collapseTipText = true;
        }


        var HoneyTipDirectiveController = Class(Controllers.BaseController, {
            constructor: HoneyTipDirectiveCtor,

            hideTip: function closeTip() {
                this.showHoneyTips = false;
            },

            likeTip: function likeTip() {
                if (!this.tipLiked) {
                    this.tipLiked = true;
                    this.HoneyTipsManager.likeTip(this.tip);
                }
            },

            toggleTipText: function toggleTipText() {
                this.collapseTipText = !this.collapseTipText;
            }
        });

        return {
            scope: {},
            templateUrl: 'angular/app/modules/common/ui_components/honey_tip/honey_tip_directive_template.html',
            controller: HoneyTipDirectiveController,
            controllerAs: 'honeyTipVm',
            bindToController: true
        };
    };
}());
